import { JsonDataType } from ".."
import { CustomInputMapping } from "../.."
import { calculateField, getCalculatedWithUnits, isValidCalculated } from "../customInputMapping"
import { formatDate, formatDateTime } from "../dateFormatting"

interface CustomInputPreviewField {
    fieldName: string
    value: string
    previewDisplayOrder: number
}

export const calcPreviewDescription = (customInputMappings: CustomInputMapping[], dataType: string, data: JsonDataType): [boolean, CustomInputPreviewField[]] => {
    const mapping = customInputMappings.find(m => m.customDataMapping.dataTypeFilter === dataType)
    if(!mapping) return [false, []]

    const fieldsToShow = mapping.customDataMapping.customFieldsMappings
        .filter(field => field.previewDisplayOrder !== null && field.previewDisplayOrder !== undefined && field.type !== 'signature'  && field.type !== 'article')
    
    if(!fieldsToShow.length) {
        const previewDescription = mapping.customDataMapping.customFieldsMappings
            .filter(field => field.type !== 'signature' && field.type !== 'article')
            .sort((field1, field2) => (field1.fieldOrder || 0) - (field2.fieldOrder || 0))
            .reduce((accum: CustomInputPreviewField[], field) => {
                const val = data[field.sourceField]
                if(!val) return accum
                let x = Array.isArray(val) ? val.join(", ") : val
                
                if(field.type === 'calculation') {
                    const [calcV, units] = calculateField(field, data)
                    const isValidCalc = isValidCalculated(calcV)
                    x = isValidCalc ? getCalculatedWithUnits(calcV, units) : ''
                }
                if(field.type === 'date') {
                    x = formatDate(x)
                }
                if(field.type === 'dateTime') {
                    x = formatDateTime(x)
                }
                return [...accum, {
                    fieldName: field.fieldName,
                    value: x,
                    previewDisplayOrder: field.fieldOrder || 0,
                }]
            }, [])
        return [!!previewDescription.length, previewDescription]
    }         
    const previewDescription: CustomInputPreviewField[] = []
    fieldsToShow.forEach(field => {
        const value = data[field.sourceField]
        if (value !== '' && value !== null && value !== undefined && !(Array.isArray(value) && !value.length)) {
            let x = Array.isArray(value) ? value.join(", ") : value

            if(field.type === 'calculation') {
                const [calcV, units] = calculateField(field, data)
                const isValidCalc = isValidCalculated(calcV)
                x = isValidCalc ? getCalculatedWithUnits(calcV, units) : ''
            }
            if(field.type === 'date') {
                x = formatDate(x)
            }
            if(field.type === 'dateTime') {
                x = formatDateTime(x)
            }

            previewDescription.push({
                fieldName: field.fieldName,
                value: x,
                previewDisplayOrder: field.previewDisplayOrder || 0
            })
        }
    })
    return [!!previewDescription.length, previewDescription]
}